<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <editor-links :config="{id: gridConfig.id, api: 'ExternalWebsites/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'LinksIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor-links': () => import(/* webpackChunkName: 'Links' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
